import {
	Card,
	CardContent,
	// CardDescription,
	CardFooter,
	CardHeader,
	CardTitle,
} from '~/components/ui/card.tsx'
import { DeleteLinkButton } from '~/routes/resources+/delete-link.tsx'

type LinkCardProps = {
	id: string
	url: string
	title: string
	// description: string | null
	image: string | undefined
	siteName: string
	isOwner: boolean
}

export default function LinkCard({
	id,
	url,
	title,
	// description,
	image,
	siteName,
	isOwner,
}: LinkCardProps) {
	return (
		<>
			{title ? (
				<div className="group relative sm:max-w-xs">
					<a href={url} target="_blank" rel="noreferrer">
						<Card className="flex h-full flex-col rounded-sm">
							<CardHeader className="flex-grow">
								<CardTitle className="text-md line-clamp-2 text-center font-normal group-hover:text-foreground-medium">
									{title}
								</CardTitle>
							</CardHeader>
							<CardContent>
								{image ? (
									<img
										className="aspect-video object-cover group-hover:opacity-75"
										src={image}
										alt={title}
									/>
								) : (
									<p className="text-center">No recipe image</p>
								)}
							</CardContent>
							<CardFooter className="flex-grow">
								<p className="w-full truncate text-right text-sm group-hover:text-foreground-medium">
									{siteName}
								</p>
							</CardFooter>
						</Card>
					</a>
					{isOwner ? (
						<div className="absolute bottom-2 left-4 z-10">
							<DeleteLinkButton linkId={id} />
						</div>
					) : null}
				</div>
			) : (
				<>
					{isOwner ? (
						<div className="group relative sm:max-w-xs">
							<Card className="flex h-full flex-col rounded-sm">
								<CardHeader className="flex-grow">
									<CardTitle className="text-md line-clamp-2 text-center font-semibold text-primary">
										Problem With Link
									</CardTitle>
								</CardHeader>
								<CardContent className="pb-8 pt-4 text-center text-sm">
									<p className="break-words pb-4 font-semibold italic leading-tight">
										{url}
									</p>
									<p className="px-6">
										Doesn't seem to be a valid link. You may want to delete this
										and create it again.
									</p>
								</CardContent>
								<CardFooter className="flex-grow"></CardFooter>
							</Card>
							{isOwner ? (
								<div className="absolute bottom-2 left-4 z-10">
									<DeleteLinkButton linkId={id} />
								</div>
							) : null}
						</div>
					) : null}
				</>
			)}
		</>
	)
}
